interface TagProps {
  label: string;
  variant?: 'primary' | 'secondary' | 'accent' | 'neutral';
}

const variantClass: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-700',
  accent: 'bg-accent-100 text-accent-800',
  neutral: 'bg-background-200 text-foreground-700',
};

export default function Tag({ label, variant = 'secondary' }: TagProps) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-label whitespace-nowrap ${variantClass[variant]}`}>
      {label}
    </span>
  );
}